import styles from "./styles/search-field.module.scss";
import searchIcon from "@/assets/searchbar/search-icon.svg";
import React from "react";
import Image from "next/image";

interface SearchFieldProps {
  searchValue: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const SearchField = ({
  searchValue,
  onChange,
  placeholder,
}: SearchFieldProps) => {
  return (
    <div className={styles.search_input_wrapper}>
      <div className={styles.input_container}>
        <input
          type={"text"}
          onChange={(e) => onChange(e.target.value)}
          value={searchValue}
          className={styles.input}
          placeholder={placeholder}
        />
        <Image className={styles.search_icon} src={searchIcon} alt={"search"} />
      </div>
    </div>
  );
};

export default SearchField;
